import React, { useEffect } from "react";
import { Drawer } from "antd";

import ParcoursClientTree from "../ParcoursClientTree";

// Drawer applicatif à droite, ouvert depuis l'AppHeader : arbre du parcours client.
// Sans masque : la vue derrière reste utilisable. Pleine hauteur : recouvre UserInfo et le bouton d'ouverture,
// la fermeture se fait donc par la croix, Échap ou un clic en dehors.

// Clics qui ne ferment pas le drawer : son panneau, le bouton d'ouverture (AppHeader, qui gère lui-même le toggle)
// et les popups antd rendues hors du drawer (menu contextuel de l'arbre)
const IGNORED_CLICK_TARGETS = ".app-drawer, .app-drawer-toggle, .ant-dropdown";

const AppDrawer = ({ open, onClose, handleSelectRequete }) => {
  // Clic en dehors : sans masque, on écoute le document. Le clic agit aussi sur la vue cliquée.
  // La racine .ant-drawer est en pointer-events: none, seul le panneau peut être la cible du clic.
  useEffect(() => {
    if (!open) return;

    const handleMouseDown = (e) => {
      if (e.target.closest(IGNORED_CLICK_TARGETS)) return;
      onClose();
    };

    document.addEventListener("mousedown", handleMouseDown);
    return () => document.removeEventListener("mousedown", handleMouseDown);
  }, [open, onClose]);

  return (
    <Drawer
      title="Parcours client"
      placement="right"
      mask={false}
      open={open}
      onClose={onClose}
      rootClassName="app-drawer"
      classNames={{ body: "app-drawer-body" }}
    >
      <ParcoursClientTree open={open} handleSelectRequete={handleSelectRequete} />
    </Drawer>
  );
};

export default AppDrawer;
